export class UserInfo {
    Email: string;
    // userId: string;
    FirstName?: string;
	LastName?: string;
	Country?: string;
	Zip?: string;
    // passwordLength?: number;
    
    // constructor(email:string, firstName: string, lastname: string, country: string, zipcode:string, passwordL: number){
    //     this.email= email;
    //     this.firstName = firstName;
    //     this.lastName = lastname;
    //     this.country = country;
    //     this.zipCode = zipcode;
    //     this.passwordLength = passwordL;
    // }
}